import { render, staticRenderFns } from "./MBTIQA.vue?vue&type=template&id=f931de52&scoped=true"
import script from "./MBTIQA.vue?vue&type=script&lang=js"
export * from "./MBTIQA.vue?vue&type=script&lang=js"
import style0 from "./MBTIQA.vue?vue&type=style&index=0&id=f931de52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f931de52",
  null
  
)

export default component.exports